import type { IHelpFile } from '../../../api/fetchers/help/fetcher';
import { useCoreSelector } from '../../CoreStore';

export const useHelpSlice = {
  getHelpFile: (): IHelpFile | null => {
    return useCoreSelector((state) => state.help.helpFile);
  },
  getIsHelpSorted: (): boolean => {
    return useCoreSelector((state) => state.help.isSorted);
  },
  getHelpNavHeight: (): number | null => {
    return useCoreSelector((state) => state.help.helpModalHeight);
  },
  getIsFetchError: (): boolean => {
    return useCoreSelector((state) => state.help.fetchError);
  },
};
